
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.29 6.274l.78-3.565a.39.39 0 00-.587-.416s-.81.492-2.403.492c-.723 0-1.162-.325-1.67-.702-.574-.43-1.226-.913-2.34-.913-2.12 0-2.823 1.214-2.86 1.266a.39.39 0 00-.038.273l.78 3.565C7.907 7.613.78 16.884 4.16 21.076c2.6 3.234 6.55 3.231 8.892 3.234h.24c2.36 0 6.24-.036 8.813-3.234 3.375-4.192-3.752-13.463-4.815-14.802zm4.21 14.3c-2.34 2.91-5.98 2.943-8.211 2.943h-.237c-2.213 0-5.917 0-8.289-2.943-1.625-2.005-.234-5.658 1.217-8.354a40.195 40.195 0 013.708-5.59.39.39 0 00.078-.33l-.78-3.575c.197-.229.795-.762 2.08-.762.852 0 1.35.37 1.874.76.526.39 1.152.855 2.135.855a6.929 6.929 0 002.08-.292l-.666 3.016a.39.39 0 00.078.33A40.156 40.156 0 0120.28 12.2c1.448 2.712 2.845 6.368 1.22 8.388v-.013z","fill":"#fff"}}),_c('path',{attrs:{"d":"M15.21 13.91a.39.39 0 00.78 0c0-1.178-1.02-2.15-2.34-2.314v-.546a.39.39 0 00-.78 0v.546c-1.32.164-2.34 1.136-2.34 2.314 0 1.178 1.02 2.148 2.34 2.311v3.12c-.89-.145-1.56-.78-1.56-1.528a.39.39 0 00-.78 0c0 1.177 1.02 2.152 2.34 2.314v.546a.39.39 0 00.78 0v-.549c1.32-.164 2.34-1.139 2.34-2.314s-1.02-2.15-2.34-2.311v-3.12c.89.148 1.56.777 1.56 1.531zm-3.9 0c0-.754.67-1.383 1.56-1.529v3.058c-.89-.146-1.56-.775-1.56-1.529zm3.9 3.9c0 .754-.67 1.386-1.56 1.529V16.28c.89.146 1.56.775 1.56 1.526v.003zM10.81 6.874a8.69 8.69 0 002.32.276 8.689 8.689 0 002.32-.276.39.39 0 10-.22-.748 8.018 8.018 0 01-2.1.244 8.018 8.018 0 01-2.1-.244.39.39 0 10-.22.748z","fill":"#fff"}})])
          )
        }
      }
    